/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../../compat/NodeCompat';
import { IVisitor } from '../visitors/IVisitor';

/**
 * Construct a node path from a string representation.
 * @param {string} path
 * @class
 * @author eric.wittmann@gmail.com
 */
export class NodePath {
    static SCAN_TYPE_PATH : number = 0;

    static SCAN_TYPE_INDEX : number = 1;

    /*private*/ segments : Array<NodePath.NodePathSegment>;

    public constructor(path? : any) {
        if(((typeof path === 'string') || path === null)) {
            let __args = arguments;
            this.segments = <any>([]);
            this.segments = <any>([]);
            (() => {
                if(path != null && path.indexOf("/") === 0 && !/* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })(path,"/"))) {
                    let currentScanType : number = NodePath.SCAN_TYPE_PATH;
                    let currentIdx : number = 1;
                    while((currentIdx < path.length)) {{
                        let segStart : number = currentIdx;
                        let segEnd : number;
                        if(currentScanType === NodePath.SCAN_TYPE_PATH) {
                            let nextPathSep : number = path.indexOf("/", segStart);
                            let nextBrace : number = path.indexOf("[", segStart);
                            if(nextPathSep === -1) {
                                nextPathSep = path.length;
                            }
                            if(nextBrace === -1) {
                                nextBrace = path.length;
                            }
                            if(nextPathSep <= nextBrace) {
                                segEnd = nextPathSep;
                            } else {
                                segEnd = nextBrace;
                            }
                        } else {
                            let nextCloseBrace : number = path.indexOf("]", segStart);
                            if(nextCloseBrace === -1) {
                                nextCloseBrace = path.length;
                            }
                            segEnd = nextCloseBrace + 1;
                        }
                        let seg : string = path.substring(segStart, segEnd);
                        let segment : NodePath.NodePathSegment = NodePath.NodePathSegment.fromString(seg);
                        /* add */(this.segments.push(segment)>0);
                        currentScanType = NodePath.SCAN_TYPE_PATH;
                        currentIdx = segEnd + 1;
                        if(segEnd >= path.length) {
                        } else if((c => c.charCodeAt==null?<any>c:c.charCodeAt(0))(path.charAt(segEnd)) == '/'.charCodeAt(0)) {
                            currentScanType = NodePath.SCAN_TYPE_PATH;
                            currentIdx = segEnd + 1;
                        } else if((c => c.charCodeAt==null?<any>c:c.charCodeAt(0))(path.charAt(segEnd)) == '['.charCodeAt(0)) {
                            currentScanType = NodePath.SCAN_TYPE_INDEX;
                            currentIdx = segEnd;
                        } else if((c => c.charCodeAt==null?<any>c:c.charCodeAt(0))(path.charAt(segEnd)) == ']'.charCodeAt(0)) {
                            if((c => c.charCodeAt==null?<any>c:c.charCodeAt(0))(path.charAt(segEnd + 1)) == '['.charCodeAt(0)) {
                                currentScanType = NodePath.SCAN_TYPE_INDEX;
                                currentIdx = segEnd + 1;
                            } else if((c => c.charCodeAt==null?<any>c:c.charCodeAt(0))(path.charAt(segEnd + 1)) == '/'.charCodeAt(0)) {
                                currentScanType = NodePath.SCAN_TYPE_PATH;
                                currentIdx = segEnd + 1;
                            }
                        }
                    }};
                }
            })();
        } else if(path === undefined) {
            let __args = arguments;
            this.segments = <any>([]);
            this.segments = <any>([]);
        } else throw new Error('invalid overload');
    }

    public prependSegment(value : string, index : boolean = false) {
        /* add */this.segments.splice(0, 0, new NodePath.NodePathSegment(value, index));
    }

    public appendSegment(value : string, index : boolean = false) {
        /* add */(this.segments.push(new NodePath.NodePathSegment(value, index))>0);
    }

    /**
     * Resolves a path to its target node within the document model.  This basically
     * walks the tree according to the path segments until it reaches the node being
     * referenced.  If the path does not point to a valid node, then this method
     * returns undefined.
     * @param {Document} document the document to resolve the path relative to
     * @return {Node}
     */
    public resolve(document : Document) : Node {
        return this.resolveWithVisitor(document, null);
    }

    /**
     * Resolves a path to its target node while also visiting all nodes along the way.
     * @param {Document} document the document to resolve the path relative to
     * @param {*} visitor an optional visitor to invoke for each node in the path (can be null)
     * @return {Node}
     */
    public resolveWithVisitor(document : Document, visitor : IVisitor) : Node {
        let node : Node = document;
        if(visitor != null) {
            node.accept(visitor);
        }
        let oNode : any = node;
        for(let index128=0; index128 < this.segments.length; index128++) {
            let segment = this.segments[index128];
            {
                oNode = segment.resolve(oNode);
                if(visitor != null && oNode != null && (oNode != null && (oNode["__interfaces"] != null && oNode["__interfaces"].indexOf("io.apicurio.datamodels.core.models.IVisitable") >= 0 || oNode.constructor != null && oNode.constructor["__interfaces"] != null && oNode.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.IVisitable") >= 0))) {
                    (<IVisitable><any>oNode).accept(visitor);
                }
            }
        }
        return <Node>oNode;
    }

    /**
     * Returns true if this path "contains" the given node.  The path is said to contain
     * a node if the node is visited while resolving it.  In other words, if one of the
     * segments of the path represents the node, then this will return true, otherwise it
     * will return false.
     * @param {Node} node
     * @return {boolean}
     */
    public contains(node : Node) : boolean {
        let tnode : any = node.ownerDocument();
        if(tnode === node) {
            return true;
        }
        for(let index129=0; index129 < this.segments.length; index129++) {
            let segment = this.segments[index129];
            {
                tnode = segment.resolve(tnode);
                if(tnode === node) {
                    return true;
                }
            }
        }
        return false;
    }

    public toSegments() : Array<string> {
        let rval : Array<string> = <any>([]);
        this.segments.forEach(((rval) => {
            return (segment) => {
                /* add */(rval.push(segment.getValue())>0);
            }
        })(rval));
        return rval;
    }

    /**
     * @see java.lang.Object#toString()
     * @return {string}
     */
    public toString() : string {
        if(/* size */(<number>this.segments.length) === 0) {
            return "/";
        }
        let rval : string = "";
        for(let index130=0; index130 < this.segments.length; index130++) {
            let segment = this.segments[index130];
            {
                if(segment.isIndex()) {
                    rval += '[' + segment.asString() + ']';
                } else {
                    rval += '/' + segment.asString();
                }
            }
        }
        return rval;
    }
}
NodePath["__class"] = "io.apicurio.datamodels.core.models.NodePath";


export namespace NodePath {

    /**
     * Constructor.
     * 
     * @param {string} value RAW (non-escaped) segment value or null
     * @param {boolean} index
     * @class
     * @author eric.wittmann@gmail.com
     */
    export class NodePathSegment {
        value : string;

        index : boolean;

        public constructor(value? : any, index? : any) {
            if(((typeof value === 'string') || value === null) && ((typeof index === 'boolean') || index === null)) {
                let __args = arguments;
                {
                    let __args = arguments;
                    if(this.value===undefined) this.value = null;
                    if(this.index===undefined) this.index = false;
                    if(this.value===undefined) this.value = null;
                    if(this.index===undefined) this.index = false;
                    (() => {
                        this.value = value;
                        this.index = false;
                    })();
                }
                (() => {
                    this.index = index;
                })();
            } else if(((typeof value === 'string') || value === null) && index === undefined) {
                let __args = arguments;
                if(this.value===undefined) this.value = null;
                if(this.index===undefined) this.index = false;
                if(this.value===undefined) this.value = null;
                if(this.index===undefined) this.index = false;
                (() => {
                    this.value = value;
                    this.index = false;
                })();
            } else throw new Error('invalid overload');
        }

        /**
         * @return {string} RAW (non-escaped) segment value or null
         */
        public getValue() : string {
            return this.value;
        }

        public isIndex() : boolean {
            return this.index;
        }

        /**
         * Resolves a single segment.
         * @param {*} from
         * @return {*}
         */
        public resolve(from : any) : any {
            if(from == null) {
                return null;
            }
            let childNode : any = null;
            if(this.isIndex() && (from != null && (from["__interfaces"] != null && from["__interfaces"].indexOf("io.apicurio.datamodels.core.models.IIndexedNode") >= 0 || from.constructor != null && from.constructor["__interfaces"] != null && from.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.IIndexedNode") >= 0))) {
                childNode = (<IIndexedNode<any>><any>from).getItem(this.getValue());
            } else if(this.getValue().indexOf("x-") === 0) {
                let fromNode : Node = <Node>from;
                if(fromNode.isExtensible()) {
                    childNode = (<ExtensibleNode>from).getExtension(this.getValue());
                } else {
                    childNode = null;
                }
            } else {
                childNode = NodeCompat.getProperty(from, this.getValue());
            }
            return childNode;
        }

        /**
         * This is a reverse operation to {@link #fromString(String)}.
         * Not using "toString" as the method name is intentional,
         * since the format of that methods output should not be assumed
         * to be stable and precisely defined.
         * 
         * @return {string} ESCAPED segment value or null
         */
        public asString() : string {
            if(this.getValue() == null) return null;
            return NodePathSegment.escapePathSegmentValue(this.getValue(), !this.isIndex());
        }

        /**
         * Creates a segment from an ESCAPED string.
         * @param {string} segment Escaped segment value. If it represents an "indexed"
         * node, it MUST be surrounded by '[' and ']'.
         * @return {NodePath.NodePathSegment}
         */
        public static fromString(segment : string) : NodePath.NodePathSegment {
            if(segment == null) {
                return new NodePath.NodePathSegment(null);
            }
            let isIndex : boolean = false;
            if(segment.indexOf("[") === 0 && segment.indexOf("]") === (segment.length - 1)) {
                segment = segment.substring(1, segment.length - 1);
                isIndex = true;
            }
            segment = NodePathSegment.unescapePathSegmentValue(segment);
            return new NodePath.NodePathSegment(segment, isIndex);
        }

        /**
         * When a path is represented as a string,
         * we are using three characters with special meaning
         * to encode it's structure.
         * '/' to separate path segments, and '[' with ']' to denote a segment for an "indexed" node.
         * Since these characters can also appear in the segment values themselves (in their non-special meaning),
         * they have to be escaped.
         * The following rules are used, inspired by <a href="https://tools.ietf.org/html/rfc6901">RFC 6901</a>:
         * - The escape character is '~', preceding a number which determines which special character is encoded.
         * - '~1' = '/'
         * - '~2' = '['
         * - '~3' = ']'
         * The escape character is itself encoded as '~0'.
         * 
         * @param {boolean} escapeSlash In the "indexed" segment, '/' can be used unescaped.
         * @param {string} rawValue
         * @return {string}
         * @private
         */
        static escapePathSegmentValue(rawValue : string, escapeSlash : boolean) : string {
            let res : string = /* replace */rawValue.split("~").join("~0");
            if(escapeSlash) res = /* replace */res.split("/").join("~1");
            res = /* replace */res.split("[").join("~2");
            res = /* replace */res.split("]").join("~3");
            return res;
        }

        /**
         * @see io.apicurio.datamodels.core.models.NodePath.NodePathSegment#escapePathSegmentValue(String, boolean)
         * @param {string} escapedValue
         * @return {string}
         * @private
         */
        static unescapePathSegmentValue(escapedValue : string) : string {
            let res : string = /* replace */escapedValue.split("~3").join("]");
            res = /* replace */res.split("~2").join("[");
            res = /* replace */res.split("~1").join("/");
            res = /* replace */res.split("~0").join("~");
            return res;
        }
    }
    NodePathSegment["__class"] = "io.apicurio.datamodels.core.models.NodePath.NodePathSegment";

}




import { ExtensibleNode } from './ExtensibleNode';


import { IIndexedNode } from './IIndexedNode';


import { IVisitable } from './IVisitable';


import { Document } from './Document';


import { Node } from './Node';

